import { FETCH_USER_SETTINGS_SUCCESS } from '../../actions/fetch-user-settings';
import { UPDATE_USER_SETTINGS_REQUEST } from '../../actions/update-user-settings';
import { LOGOUT_MEMBER_SUCCESS } from '../../actions/logout-member';

export default (state = null, { type, payload = {} } = {}) => {
  switch (type) {
    case FETCH_USER_SETTINGS_SUCCESS:
    case UPDATE_USER_SETTINGS_REQUEST:
      return payload;
    case LOGOUT_MEMBER_SUCCESS:
      return null;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/auth/current-user-settings.js